module.exports = __webpack_public_path__ + "static/media/rewards-marker.ed3097ac.svg";